import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { MandatoryLearningStatusVessel } from '@routes/sidebar/admin-center/fleet-dashboard/___shared___/types.ts';

interface FleetVesselError {
    message?: string;
    [k: string]: any;
}

interface FleetVesselState {
    error: FleetVesselError | null;
    selectedVessel: MandatoryLearningStatusVessel | null;
    selectedCrewStatusPillFilter: string | null; // will be sent as { filterName: ['True'|'False'] }
}

const initialState: FleetVesselState = {
    error: null,
    selectedVessel: null,
    selectedCrewStatusPillFilter: null,
};

const adminCenterFleetVesselSlice = createSlice({
    name: 'adminCenterFleetVessel',
    initialState,
    reducers: {
        setSelectedVessel(state, action: PayloadAction<MandatoryLearningStatusVessel | null>) {
            state.selectedVessel = action.payload;
        },
        setSelectedCrewStatusPillFilter: (state, action: PayloadAction<string | null>) => {
            state.selectedCrewStatusPillFilter = action.payload;
        },
    },
    extraReducers: () => {},
});

export const { setSelectedVessel, setSelectedCrewStatusPillFilter } = adminCenterFleetVesselSlice.actions;

export default adminCenterFleetVesselSlice.reducer;
